import { GET_COMMUNICATED, GET_COMMUNICATION, GET_TEMPLATES, GET_TEMPLATE } from '../actions/types';

import { INITIAL_STATE } from '../states/states';

export default (state = INITIAL_STATE.COMMUNICATED, action) => {
  switch (action.type) {
    case GET_COMMUNICATED:
      return { ...state, communicated: action.payload };
    case GET_COMMUNICATION:
      return { ...state, communicatedInfo: action.payload };
    case GET_TEMPLATES:
      return { ...state, templates: action.payload };
    case GET_TEMPLATE:
      return { ...state, template: action.payload };
    default:
      return state;
  }
};
